<template lang="pug">
v-sheet(:style='styles', tile='', :color="color", v-bind='$attrs')
  slot
</template>

<script setup>
defineOptions({ name: 'BaseSection' })

const props = defineProps({
  space: {
    type: [Number, String],
    default: 96,
  },
  color: {
    type: String,
    default: 'surface',
  },
})

const styles = computed(() => ({
  '--section-space': `${Number(props.space)}px`,
}))
</script>

<style scoped>
.v-sheet {
  padding: calc(var(--section-space) / 4) 0;
}

@media (min-width: 960px) {
  .v-sheet {
    padding: calc(var(--section-space) / 2) 0;
  }
}
</style>
